import React from 'react';

import { Typography } from '@lyearn/ui';

import { useActionItemContext } from '../../context';
import { ActionIdentifierProps } from '../../types';

const ActionIdentifier = ({ className, ...props }: ActionIdentifierProps) => {
  const {
    actionItem: { identifier },
    disableInteractiveTooltip = false,
  } = useActionItemContext();

  return (
    <Typography className={className} {...props}>
      <>{identifier}</>
      {/* {title} */}
    </Typography>
  );
};

export default React.memo(ActionIdentifier);
